/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SlackMessage
 */
export interface SlackMessage {
    /**
     * 
     * @type {string}
     * @memberof SlackMessage
     */
    recipient: string;
    /**
     * 
     * @type {string}
     * @memberof SlackMessage
     */
    text: string;
    /**
     * 
     * @type {string}
     * @memberof SlackMessage
     */
    username?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SlackMessage
     */
    emoji?: string | null;
}

export function SlackMessageFromJSON(json: any): SlackMessage {
    return SlackMessageFromJSONTyped(json, false);
}

export function SlackMessageFromJSONTyped(json: any, ignoreDiscriminator: boolean): SlackMessage {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'recipient': json['recipient'],
        'text': json['text'],
        'username': !exists(json, 'username') ? undefined : json['username'],
        'emoji': !exists(json, 'emoji') ? undefined : json['emoji'],
    };
}

export function SlackMessageToJSON(value?: SlackMessage | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'recipient': value.recipient,
        'text': value.text,
        'username': value.username,
        'emoji': value.emoji,
    };
}


